/* ==========================================================================
   MRPIECE — Mix & Match landing page.

   Two jobs only. Everything else on this page is CSS.

   1. Reveal on scroll. The theme has its own reveal system driven by an
      observer that is dead on this store, so this page brings its own rather
      than inheriting one that may never fire. Elements start hidden ONLY once
      this script confirms it can observe them, so a JavaScript failure leaves
      the page fully readable instead of blank.

   2. Double the marquee track so the loop has something to scroll into. Doing
      it here rather than in Liquid keeps the copy written once.
   ========================================================================== */
(function () {
  'use strict';

  function marquee() {
    var tracks = document.querySelectorAll('[data-mmlp-marquee]');
    Array.prototype.forEach.call(tracks, function (track) {
      if (track.dataset.doubled === '1') return;
      track.dataset.doubled = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  function reveal() {
    var items = document.querySelectorAll('[data-mmlp-reveal]');
    if (!items.length) return;

    // No observer, no hiding. The content is the point; the animation is not.
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(items, function (el) {
      el.classList.add('mmlp-reveal');
      io.observe(el);
    });
  }

  // The builder is a shared section with no anchor of its own, so the page
  // gives it one here rather than forking that file just to add an id.
  function anchorBuilder() {
    var root = document.querySelector('[data-mm-root]');
    if (!root) return;
    var host = root.closest('.shopify-section') || root;
    if (!host.id || host.id.indexOf('shopify-section') === 0) host.id = 'mm-builder';
  }

  function smoothScroll() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('a[href="#mm-builder"]') : null;
      if (!link) return;
      var target = document.getElementById('mm-builder');
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function boot() { marquee(); anchorBuilder(); reveal(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  smoothScroll();
  document.addEventListener('shopify:section:load', boot);
})();
